// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_HrAyJ","loading":"style_loading_1ZNno","bg":"style_bg_3Em3a","title":"style_title_26xkD","titleMode":"style_titleMode_2pLmN"};